// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"Edit_deleteButton__rawMG"};